import React from "react";
import { useState } from "react";
import { Card } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import { FaUser, FaChevronDown, FaChevronRight } from "react-icons/fa";

const TreeNode = ({
  member,
  level,
  isLastChild,
  siblingCount,
  siblingIndex,
}) => {
  const [isExpanded, setIsExpanded] = useState(level === 0);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const nodeVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  const childrenVariants = {
    hidden: { opacity: 0, height: 0 },
    visible: { opacity: 1, height: "auto" },
  };

  return (
    <div
      className={`tree-node ${isLastChild ? "last-child" : ""} ${
        siblingCount > 1 ? "has-siblings" : ""
      }`}
    >
      <div className="tree-content">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={nodeVariants}
          transition={{ duration: 0.3, delay: level * 0.1 }}
        >
          <Card className="family-card">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div className="user-icon">
                    <FaUser className="text-pink-600" aria-hidden="true" />
                  </div>
                  <span className="font-weight-bold ml-2">{member.name}</span>
                </div>
                {member.children && member.children.length > 0 && (
                  <button
                    onClick={toggleExpand}
                    aria-expanded={isExpanded}
                    className="expand-button"
                    aria-label={isExpanded ? "Collapse" : "Expand"}
                  >
                    {isExpanded ? (
                      <FaChevronDown aria-hidden="true" />
                    ) : (
                      <FaChevronRight aria-hidden="true" />
                    )}
                  </button>
                )}
              </div>
            </Card.Body>
          </Card>
        </motion.div>
      </div>
      <AnimatePresence>
        {isExpanded && member.children && (
          <motion.div
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={childrenVariants}
            transition={{ duration: 0.3 }}
            className="tree-children"
          >
            {member.children.map((child, index) => (
              <TreeNode
                key={child.name}
                member={child}
                level={level + 1}
                isLastChild={index === member.children.length - 1}
                siblingCount={member.children.length}
                siblingIndex={index}
              />
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const familyData = {
  name: "ભીખુભા આણંદસિંહ ઝાલા",
  children: [
    {
      name: "બાવુભા ભીખુભા ઝાલા",
      children: [
        {
          name: "મહાવીરસિંહ બાવુભા ઝાલા",
          children: [
            {
              name: "હિતેન્દ્રસિંહ મહાવીરસિંહ ઝાલા",
              children: [
                {
                  name: "બ્રિજરાજસિંહ હિતેન્દ્રસિંહ ઝાલા",
                  children: [{ name: "રુદ્રાક્ષસિંહ બ્રિજરાજસિંહ ઝાલા" }],
                },
                { name: "તીર્થરાજસિંહ હિતેન્દ્રસિંહ ઝાલા (વરરાજા)" },
              ],
            },
          ],
        },
        {
          name: "લખધીરસિંહ બાવુભા ઝાલા",
          children: [
            {
              name: "ધર્મપાલસિંહ લખધીરસિંહ ઝાલા (ટીકુ રાણા)",
              children: [
                { name: "સત્યમસિંહ ધર્મપાલસિંહ ઝાલા" },
                { name: "કાવ્યરાજસિંહ ધર્મપાલસિંહ ઝાલા" },
              ],
            },
          ],
        },
        {
          name: "કિશોરસિંહ બાવુભા ઝાલા",
          children: [
            {
              name: "લક્ષ્મણસિંહ કિશોરસિંહ ઝાલા",
              children: [{ name: "રૂદ્રરાજસિંહ લક્ષ્મણસિંહ ઝાલા" }],
            },
          ],
        },
        {
          name: "હસેન્દ્રસિંહ બાવુભા ઝાલા",
          children: [{ name: "રવિરાજસિંહ હસેન્દ્રસિંહ ઝાલા" }],
        },
      ],
    },
    {
      name: "ચંદ્રસિંહ ભીખુભા ઝાલા (રાજસાહેબશ્રી બાપુ)",
      children: [
        {
          name: "હાલુભા ચંદ્રસિંહ ઝાલા",
          children: [
            {
              name: "દિગ્વિજયસિંહ હાલુભા ઝાલા",
              children: [{ name: "રુતુરાજસિંહ દિગ્વિજયસિંહ ઝાલા" }],
            },
            {
              name: "મયુરસિંહ હાલુભા ઝાલા",
              children: [{ name: "ભવ્યરાજસિંહ મયુરસિંહ ઝાલા" }],
            },
          ],
        },
        {
          name: "કિરતસિંહ ચંદ્રસિંહ ઝાલા",
          children: [{ name: "ધર્મરાજસિંહ કિરતસિંહ ઝાલા" }],
        },
        {
          name: "ભુપતસિંહ ચંદ્રસિંહ ઝાલા",
          children: [
            {
              name: "કલ્પરાજસિંહ ભુપતસિંહ ઝાલા",
              children: [{ name: "આદિત્યરાજસિંહ કલ્પરાજસિંહ ઝાલા" }],
            },
          ],
        },
        {
          name: "સહદેવસિંહ ચંદ્રસિંહ ઝાલા",
          children: [
            {
              name: "કર્મદીપસિંહ સહદેવસિંહ ઝાલા",
              children: [{ name: "આર્યરાજસિંહ કર્મદીપસિંહ ઝાલા" }],
            },
          ],
        },
      ],
    },
  ],
};

const FamilyTree = () => {
  return (
    <div className="container mt-4">
      <h1 className="mb-4 text-center" style={{ padding: "0px" }}>
        ભીખુભા બાપુ નો પરીવાર
      </h1>

      <div className="family-tree-container">
        <TreeNode
          member={familyData}
          level={0}
          isLastChild={true}
          siblingCount={1}
          siblingIndex={0}
        />
      </div>
    </div>
  );
};

export default FamilyTree;
